import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { makeStyles } from '@mui/styles'
import PerfectScrollbar from 'react-perfect-scrollbar'

import lang from '@/lang'
import { useAppDispatch } from '@/redux/store'
import NotificationList from '@/modules/base/components/notification/overlay/notification-list'
import { fetchNewsfeedData, markAllAsRead } from 'redux/ducks/newsfeed'

const useStyles = makeStyles(theme => ({
  headline: {
    backgroundColor: theme.mode.backgroundColor.default,
    color: theme.mode.color.default,
    fontSize: 17,
    padding: '25px 30px',
    '&:first-of-type': {
      borderTop: 'none',
    },
  },
  scrollbar: {
    '& .ps__rail-y': {
      zIndex: 1,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: 20,
    padding: '25px 30px 10px',
    color: theme.mode.color.default,
  },
  title: {
    fontSize: theme.fontSizes.large,
    fontWeight: theme.fontWeights.semiBold,
  },
  markAll: {
    whiteSpace: 'nowrap',
  },
}
))

const Headline = ({ children }) => {
  const classes = useStyles()
  return <div className={classes.headline}>{children}</div>
}

const Notifications = () => {
  const classes = useStyles()
  const dispatch = useAppDispatch()
  const { items, unreadCount } = useSelector(state => state.newsfeed)

  const [todaysNotifications, setTodaysNotifications] = useState([])
  const [yesterdaysNotifications, setYesterdaysNotifications] = useState([])
  const [weeksNotifications, setWeeksNotifications] = useState([])
  const [olderNotifications, setOlderNotifications] = useState([])

  useEffect(() => {
    dispatch(fetchNewsfeedData())
  }, [])

  const categorizeNotifications = items => {
    const today = moment()
    const yesterday = moment().subtract(1, 'days')

    const todays = []
    const yesterdays = []
    const weeks = []
    const older = []

    items.map(item => {
      if (today.isSame(item.createdAt, 'day')) todays.push(item)
      else if (yesterday.isSame(item.createdAt, 'day')) yesterdays.push(item)
      else if (today.isSame(item.createdAt, 'week')) weeks.push(item)
      else older.push(item)
    })

    return { todays, yesterdays, weeks, older }
  }

  useEffect(() => {
    const { todays, yesterdays, weeks, older } = categorizeNotifications(items)

    setTodaysNotifications(todays)
    setYesterdaysNotifications(yesterdays)
    setWeeksNotifications(weeks)
    setOlderNotifications(older)
  }, [items])

  return (
    <PerfectScrollbar className={classes.scrollbar}>
      <div className={classes.header}>
        <span className={classes.title} data-qs-id='notifications-title'>{lang.notifications.title}</span>
        {unreadCount > 0 && <a className={classes.markAll} onClick={() => dispatch(markAllAsRead())} data-qs-id='notifications-mark-all'>{lang.notifications.markAll}</a>}
      </div>
      {!!todaysNotifications.length && (
        <Fragment>
          <Headline>{lang.notifications.today.title}</Headline>
          <NotificationList notifications={todaysNotifications} dateFormat={lang.notifications.today.dateFormat} />
        </Fragment>
      )}

      {!!yesterdaysNotifications.length && (
        <Fragment>
          <Headline>{lang.notifications.yesterday.title}</Headline>
          <NotificationList notifications={yesterdaysNotifications} dateFormat={lang.notifications.yesterday.dateFormat} />
        </Fragment>
      )}

      {!!weeksNotifications.length && (
        <Fragment>
          <Headline>{lang.notifications.week.title}</Headline>
          <NotificationList notifications={weeksNotifications} dateFormat={lang.notifications.week.dateFormat} />
        </Fragment>
      )}

      {!!olderNotifications.length && (
        <Fragment>
          <Headline>{lang.notifications.older.title}</Headline>
          <NotificationList notifications={olderNotifications} dateFormat={lang.notifications.older.dateFormat} />
        </Fragment>
      )}
    </PerfectScrollbar>
  )
}

export default Notifications
